<template>
  <div class="icon-box" @click="onClick()">
    <svg :class="`icon ${asc ? 'asc' : 'desc'}`" viewBox="0 0 20 20" height="15" width="15" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h20v20H0V0z" fill="none" />
      <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" />
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ArrowIcon',
  props: {
    asc: {
      type: Boolean,
    },
  },
  emits: ['onClick'],
  /**
   * setup
   * @param props - props
   */
  setup(props, { emit }) {
    /**
     * onClick
     */
    const onClick = () => {
      emit('onClick');
    };
    return {
      onClick,
    };
  },
});
</script>

<style scoped>
.icon-box {
  cursor: pointer;
}
.icon {
  transform: rotateX(180deg);
}
.desc {
  transform: rotateX(180deg);
  transition: transform 0.2s;
  margin-top: 4px;
}
.asc {
  transform: rotateX(360deg);
  transition: transform 0.2s;
  margin-bottom: 4px;
}
</style>
